export const EditIcon = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.8335 2.66666H4.0335C2.91339 2.66666 2.35334 2.66666 1.92552 2.88464C1.54919 3.07639 1.24323 3.38235 1.05148 3.75867C0.833496 4.1865 0.833496 4.74655 0.833496 5.86666V11.4667C0.833496 12.5868 0.833496 13.1468 1.05148 13.5746C1.24323 13.951 1.54919 14.2569 1.92552 14.4487C2.35334 14.6667 2.91339 14.6667 4.0335 14.6667H9.6335C10.7536 14.6667 11.3137 14.6667 11.7415 14.4487C12.1178 14.2569 12.4238 13.951 12.6155 13.5746C12.8335 13.1468 12.8335 12.5868 12.8335 11.4667V8.66666M4.83348 10.6667H5.94984C6.27596 10.6667 6.43902 10.6667 6.59247 10.6298C6.72852 10.5972 6.85858 10.5433 6.97788 10.4702C7.11243 10.3877 7.22773 10.2724 7.45833 10.0418L13.8335 3.66666C14.3858 3.11437 14.3858 2.21894 13.8335 1.66666C13.2812 1.11437 12.3858 1.11437 11.8335 1.66665L5.45832 8.04182C5.22772 8.27242 5.11241 8.38772 5.02996 8.52228C4.95685 8.64157 4.90298 8.77163 4.87032 8.90768C4.83348 9.06113 4.83348 9.22419 4.83348 9.55031V10.6667Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 1H9M1 3H13M11.6667 3L11.1991 10.0129C11.129 11.065 11.0939 11.5911 10.8667 11.99C10.6666 12.3412 10.3648 12.6235 10.0011 12.7998C9.58798 13 9.06073 13 8.00623 13H5.99377C4.93927 13 4.41202 13 3.99889 12.7998C3.63517 12.6235 3.33339 12.3412 3.13332 11.99C2.90607 11.5911 2.871 11.065 2.80086 10.0129L2.33333 3M5.66667 6V9.33333M8.33333 6V9.33333"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SidebarIconSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#000000"
  >
    <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
  </svg>
);

export const PinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#ffffff"
  >
    <path d="m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40v280Zm-286 80h252l-46-46v-314H400v314l-46 46Zm126 0Z" />
  </svg>
);
